module.exports = __webpack_public_path__ + "img/team-2.567aa5be.png";